import { render, staticRenderFns } from "./ShortcutRow.vue?vue&type=template&id=2a0402d9&scoped=true&"
import script from "./ShortcutRow.vue?vue&type=script&lang=js&"
export * from "./ShortcutRow.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutRow.vue?vue&type=style&index=0&id=2a0402d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0402d9",
  null
  
)

export default component.exports